// global service for global variables
export let Global = function () {
    var _this = this;
    _this._data = {
        version: window.version,
        api: api
    };
    return _this._data;
}


/** WEBPACK FOOTER **
 ** ./src/system/services/global.ts
 **/